/* eslint-disable sort-keys-fix/sort-keys-fix */
import { COMMUNITY_PAGES_PATH_PREFIX, type CommunityData } from "./types"

const trillah: CommunityData = {
  code: "trillah",
  inviteCode: "trillahhillah22",
  name: "Trillah Hillah",
  thumbnail: "https://media.werz.at/web/trillah-thumbnail.jpg",
  favicon: "",
  url: `${COMMUNITY_PAGES_PATH_PREFIX}/trillah`,
  socials: {
    instagramLink: "",
    soundcloudLink: "",
  },
  styles: {
    global: {
      counterColor: "#211418",
      logo: {
        src: "/assets/customizations/trillah/logo.svg",
        styles: "w-[96px]",
      },
      modalWindow: {
        container: "",
        title: "",
        subtitle: "",
      },
      contentBoxShadow: "",
      bgColor: "#fff2ea",
      asideStyles: "",
      asideBg: "#EFD4F5",
      contentBg: "#F5E5F9",
      bgDesktop: "/assets/images/trillah-bg.png",
      bgMobile: "/assets/images/trillah-bg.png",
      mainFont: "font-['SometypeMono']",
      primaryButton:
        "!px-6 w-full sm:w-fit !h-[60px] bg-[#6B137F] rounded-[100px] !text-[16px] !leading-[20px] font-['MegaBoxs'] !text-white",
    },
    navigation: {
      sideBarSeparator: "",
      iconsColor: "",
      separator: "border-black border-t",
      item: "font-['MegaBoxs'] text-[18px] leading-[18px] h-[40px] flex sm:justify-start justify-center items-center",
      itemSelected: "bg-[#232734] text-[#EFD4F5]",
    },
    communityLanding: {
      emptyOrLoadingState: "",
      titles: "font-['MegaBoxs'] text-[#E15581] text-[24px] leading-[24px] pb-2",
      announcements: {
        lg: {
          title: "text-[20px] leading-[28px] font-bold",
          subtitle: "text-[12px] leading-[12px] font-bold",
        },
        sm: {
          title: "text-[20px] leading-[28px] font-bold",
          subtitle: "text-[12px] leading-[12px] font-bold",
        },
      },
      event: {
        title: "text-[13px] leading-5 font-bold text-[#E15581]",
        subtitle: "text-[13px] leading-5 font-bold",
      },
      shop: {
        title: "text-[20px] leading-[20px] font-['MegaBoxs'] text-[#E15581]",
        text: "text-[13px] leading-[24px] font-medium",
        customShopImage: "/assets/customizations/trillah/img_shop.png",
      },
    },
    announcements: {
      emptyOrLoadingState: "",
      created: "",
      container: "mb-16 p-11 pb-8 space-y-[57px]",
      header: "font-bold text-[#0000FF] text-[24px] leading-[24px] font-['MegaBoxs']",
      title: "font-['MegaBoxs'] text-[#E15581] text-[24px] leading-[24px] pb-2",
      description: "text-[12px] leading-[12px] font-bold",
    },
    announcement: {
      emptyOrLoadingState: "",
      created: "",
      container: "mb-16 p-11 pb-8 space-y-[23px]",
      title: "font-['MegaBoxs'] text-[#E15581] text-[24px] leading-[24px] pb-2",
      description: "text-[12px] leading-[12px] font-bold",
      commentIconColor: "",
      likeIconColor: "",
      likeCount: "",
      commentCount: "",
    },
    event: {
      emptyOrLoadingState: "",
      blockContainer: "flex flex-col gap-3",
      container: "flex flex-col sm:p-11 p-6 ",
      sectionTitle: "text-[32px] font-['MegaBoxs'] leading-10 sm:leading-8 text-[#E15581]",
      sectionSubtitle: "text-[16px] leading-[16px] font-medium",
      text: "text-[13px] leading-[28px]",
      separator: "border-b border-b-[#E15581] border-opacity-20",
      header:
        "sm:text-[32px] sm:leading-[32px] mt-2 font-['MegaBoxs'] text-[28px] leading-[28px] sm:mb-0 mb-5 text-[#E15581]",
      map: {
        pin: "",
        border: "",
        pinColor: "#E15581",
        strokeColor: "border-[#E15581]",
      },
    },
    events: {
      sectionHeader: "uppercase font-['MegaBoxs']",
      container: "mb-16 sm:p-11 p-7 sm:pb-8 sm:space-y-[57px] space-y-[25px]",
      header: "font-bold text-[#0000FF] text-[24px] leading-[24px] font-['MegaBoxs']",
      title: "font-bold text-[20px] leading-[20px] my-4",
      emptyOrLoadingState: "font-bold text-[20px] leading-[20px] my-8 uppercase",
      duration: "font-medium text-[13px] leading-[13px] mb-4",
      address: "text-[12px] leading-[12px] uppercase",
      separator: "mb-8 mt-2 border-b border-b-[1px] border-black",
    },
    eventTickets: {
      container: "p-7 pb-10 sm:p-6 sm:pb-[62px] sm:w-[960px]",
      separator: "border-b border-b-[#E15581] border-opacity-20",
      event: {
        title: "text-[32px] leading-[1] font-['MegaBoxs'] text-[#E15581]",
        subtitle: "text-[16px] leading-[16px] font-medium",
      },
      ticket: {
        counterContainer: "",
        title: "text-[24px] leading-[1] font-['MegaBoxs'] text-[#E15581]",
        description: "text-[16px] leading-[16px] font-bold",
        text: "text-[13px] leading-[20px]",
        price: "text-[24px] leading-[1] font-bold",
        quantity: "text-[20px] leading-[1] font-bold",
      },
    },
  },
}

export default trillah
